angular.module("app").service( 'dateRangeFilter', function(){
    this.getDateRangeFilterOptions = function (timepicker, partnerTime, ranges, customRanges, transactionRelatedDates) {
        var obj = {},
            customRangesObj = {};
        obj.autoApply = true;
        if(timepicker){
            obj.timePicker = true;
            obj.timePicker24Hour = true;
            obj.timePickerIncrement = true;
        }
        if(customRanges && Array.isArray(customRanges)){
            var length = customRanges.length,
                item;
            for(var i = 0; i < length; i++){
                item = customRanges[i];
                customRangesObj[item.rangeName] = item.val;
            }
        }
        if(ranges){
            obj.ranges = partnerTime ? _.extend(customRangesObj,{
                    'Today': [moment().format("DD-MM-YY - ") + partnerTime, moment().add(1, 'days').format("DD-MM-YY - ") + partnerTime],
                    'Yesterday': [moment().subtract('days', 1).format("DD-MM-YY - ") + partnerTime, moment().format("DD-MM-YY - ") + partnerTime],
                    'Last 7 days': [moment().subtract('days', 7).format("DD-MM-YY - ") + partnerTime, moment().format("DD-MM-YY - ") + partnerTime],
                    'Last 30 days': [moment().subtract('days', 30).format("DD-MM-YY - ") + partnerTime, moment().format("DD-MM-YY - ") + partnerTime],
                    'This month': [moment().startOf('month').format("DD-MM-YY - ") + partnerTime, moment().endOf('month').format("DD-MM-YY - ") + partnerTime]
                }):
                timepicker ? _.extend(customRangesObj,{
                        'Today': [moment().format("DD-MM-YY - HH:mm:ss"), moment().add(1, 'days').format("DD-MM-YY - HH:mm:ss")],
                        'Yesterday': [moment().subtract('days', 1).format("DD-MM-YY - HH:mm:ss"), moment().format("DD-MM-YY - HH:mm:ss")],
                        'Last 7 days': [moment().subtract('days', 7).format("DD-MM-YY - HH:mm:ss"), moment().format("DD-MM-YY - HH:mm:ss")],
                        'Last 30 days': [moment().subtract('days', 30).format("DD-MM-YY - HH:mm:ss"), moment().format("DD-MM-YY - HH:mm:ss")],
                        'This month': [moment().startOf('month').format("DD-MM-YY - HH:mm:ss"), moment().endOf('month').format("DD-MM-YY - HH:mm:ss")]
                    }):
                    transactionRelatedDates ? _.extend(customRangesObj,{
                            'Today': [moment().format("DD-MM-YY"), moment().format("DD-MM-YY")],
                            'Yesterday': [moment().subtract('days', 1).format("DD-MM-YY"), moment().subtract('days', 1).format("DD-MM-YY")],
                            'Last 7 days': [moment().subtract('days', 7).format("DD-MM-YY"), moment().format("DD-MM-YY")],
                            'Last 30 days': [moment().subtract('days', 30).format("DD-MM-YY"), moment().format("DD-MM-YY")],
                            'This month': [moment().startOf('month').format("DD-MM-YY"), moment().endOf('month').format("DD-MM-YY")]
                        }):
                        _.extend(customRangesObj,{
                            'Today': [moment().format("DD-MM-YY"), moment().add(1, 'days').format("DD-MM-YY")],
                            'Yesterday': [moment().subtract('days', 1).format("DD-MM-YY"), moment().format("DD-MM-YY")],
                            'Last 7 days': [moment().subtract('days', 7).format("DD-MM-YY"), moment().format("DD-MM-YY")],
                            'Last 30 days': [moment().subtract('days', 30).format("DD-MM-YY"), moment().format("DD-MM-YY")],
                            'This month': [moment().startOf('month').format("DD-MM-YY"), moment().endOf('month').format("DD-MM-YY")]
                        });
        }

        obj.locale = {
            "direction": "ltr",
            "format": timepicker ? "DD-MM-YY HH:mm" : "DD-MM-YY",
            "separator": " - ",
            "applyLabel": "Apply",
            "cancelLabel": "Cancel",
            "fromLabel": "From",
            "toLabel": "To",
            "customRangeLabel": "Custom",
            "daysOfWeek": [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa"
            ],
            "monthNames": [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            "firstDay": 1
        };
        return obj;
    };


});